import { z } from 'zod';
import { requiredString } from '../helpers';
export const Hubspot_Send_Transactional_Email_1_ConfigValidator = z.object({
    hubspotConnection: requiredString('HubSpot Connection is required'),
    emailId: requiredString('Email ID is required'),
    messageTo: z.string().optional(),
    messageFrom: z.string().optional(),
    messageCC: z.string().optional(),
    messageBcc: z.string().optional(),
    messageReplyTo: z.string().optional(),
    messageSendId: z.string().optional(),
    contactProperties: z.record(z.string(), z.string().optional()).optional(),
    customProperties: z.record(z.string(), z.string().optional()).optional()
});
//# sourceMappingURL=hubspot-send-transactional-email-1.js.map